import { gql, useQuery, useLazyQuery } from '@apollo/client';

const query = gql`
  query GetBorrowers {
    getBorrowers {
      _id
      name
      lastName
      email
      phone
    }
  }
`

const checkEmailQuery = gql`
  query CheckBorrowerEmailExists($email: String!) {
    checkBorrowerEmailExists(email: $email)
  }
`

export const useGetBorrowers = () => {
  const { data, loading, error } = useQuery(
    query,
    { fetchPolicy: 'no-cache' }
  );

  return {
    data,
    loading,
    error
  };
};

export const useCheckBorrowerEmailExists = () => {
  const [checkEmail, { data, loading, error }] = useLazyQuery(checkEmailQuery);

  return {
    checkEmail,
    emailExists: data?.checkBorrowerEmailExists || false,
    loading,
    error
  };
};